import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { accountId: String }

  connect() {
    try {
      if (window.localStorage.getItem(this.storageKey) === "dismissed") {
        this.element.remove()
        return
      }
    } catch {
      // The notice remains usable when browser storage is unavailable.
    }
    this.element.hidden = false
  }

  dismiss() {
    try {
      window.localStorage.setItem(this.storageKey, "dismissed")
    } catch {
      // Closing the notice must still work without browser storage.
    }
    this.element.remove()
  }

  get storageKey() {
    return `appsignal.freePlanNotice.30k-v1.${this.accountIdValue}`
  }
}
